<ng-template #titleTpl>
  @if (brandLogoTitle) {
    <sd-banner class="c__brand-logo-title" [isFit]="true" [media]="brandLogoTitle" />
  }
  <sd-title
    [titleLevel]="titleLevel"
    [customClass]="isSmall && !largeTitle ? 'brand--h5 c__title' : 'brand--h4 c__title'"
    [attr.aria-hidden]="isTitleAriaHidden"
  >
    {{title}}
  </sd-title>
</ng-template>

@if (!isLoading) {
  @if (title) {
    @if (productUrl) {
      <sd-link
        [indexFollow]="indexFollow"
        [link]="{url: productUrl}"
        customClass="is-full-area c__title-link is-reset"
        (clicked)="onProductClick()"
      >
        <ng-container *ngTemplateOutlet="titleTpl" />
      </sd-link>
    } @else {
      <ng-container *ngTemplateOutlet="titleTpl" />
    }
  }
  @if (ratings && !isSmall) {
    <sd-rating
      [labelTitle]="'product.rating' | translate"
      [labelHidden]="true"
      [indexFollow]="indexFollow"
      [hideRatingLabel]="hideRatingLabel"
      [hideRatingStars]="hideRatingStars"
      [hideRatingNumber]="hideRatingNumber"
      [showAverageRatingsLabel]="true"
      [ratingSize]="ratingSize"
      [readonly]="true"
      (reviewsSeeAllClicked)="onReviewsSeeAllClicked()"
      [ratings]="ratings"
    />
  }

  <ng-content select="[sd-benefits-list]" />
  <ng-content select="[sd-product-features]" />
  <ng-content select="[sd-compatible-product]" />

  @if (!isMinified) {
    <div class="c__legal-notice">
      <ng-content select="[sd-promo]" />
      @if (((productCode && !isBundle) || (productRefSAV && !isBundle)) && showRef) {
        <p class="{{horizontalParentLayout ? 'is-overline' : 'is-body-s'}} c__ref" [ngClass]="{'has-read-more': productRefSAV?.length > numberOfRefSavToDisplay}">
          @if (productCode && !isBundle) {
            <span>{{ "product.ref" | translate }} {{ productCode }}</span>
          }
          @if (productRefSAV && !isBundle) {
            <span>
              @for (refSAV of productRefSAV | slice:0:numberOfRefSavToDisplay; track refSAV) {
                <ng-container *ngTemplateOutlet="templateRefSAV; context: {
                  refSAV: refSAV,
                  hasComma: $index < (numberOfRefSavToDisplay - 1) && productRefSAV?.length > 1
                }" />
              }
              @if (productRefSAV?.length > numberOfRefSavToDisplay) {
                <span>...</span>
                <button type="button" class="c__toggle is-link is-full-area" (click)="onClickReadMore(productUrl)">
                  <span class="is-caption is-bold">{{ 'actions.readMore' | translate }}</span>
                  <sd-icon name="icon-arrow-right" [size]="iconSize.xs" />
                </button>
              }
            </span>
          }
        </p>
      }
      @if (subtitle && !isSmall && !isMinified) {
        <sd-html
          innerClass="c__subtitle {{horizontalParentLayout ? 'is-overline' : 'is-caption'}}"
          [html]="subtitle"
        />
      }
      @if (productSeller && onSale) {
        <sd-product-seller
          [isLoading]="isLoading"
          [horizontalParentLayout]="horizontalParentLayout"
          (toggleModalChange)="toggleProductSellerModal($event)"
          [text]="productSeller?.text"
        />
      }
    </div>
  }
  @if (iAdvizeEnabled()) {
    <div class="c__product-question-block" [id]="iAdvizeId()"></div>
  }
  <div class="c__price-block">
    @if (!isMinified && price) {
      <sd-price
        [discountedPrice]="discountedPrice"
        [isSSR]="isSSR"
        [price]="price"
        [isSmall]="!isProductDetails"
        [isBundle]="isBundle"
        [recommendedPrice]="recommendedPrice"
        [isSmallRecommendedPrice]="isSmallRecommendedPrice"
        [isDiscountWithRecommendedPrice]="isDiscountWithRecommendedPrice"
        (openRecommendedPriceModal)="onopenRecommendedPriceModal()"
      />
    }
    @if (displayStock || ecoTax || isTaxesIncluded || reparabilityData || promoQualiRepar) {
      <div class="c__price-info-wrapper">
        @if (isTaxesIncluded && price) {
          <p class="is-caption">
            {{'product.taxesIncluded' | translate }}
          </p>
        }
        @if (ecoTax) {
          <p class="c__legal-content is-caption is-regular">
            {{ 'product.price.ecoTax' | translate: {ecoTax: ecoTax} }}
          </p>
        }
        @if (reparabilityData) {
          <sd-reparability
            [reparabilityData]="reparabilityData"
            [brand]="brand"
            (reparabilityLinkClick)="onRepairabilityLinkClick()"
            (repairabilityInfoClick)="onRepairabilityInfoClick()"
          />
        }
        @if (promoQualiRepar) {
          <sd-product-promo sd-promo [isQualiRepar]="true" [promo]="promoQualiRepar" />
        }
        <div class="c__payment-modes">
          @if (klarnaData && !dividedData) {
            <klarna-placement
              data-key="credit-promotion-badge"
              [attr.data-locale]="klarnaData.locale"
              [attr.data-purchase-amount]="klarnaData.price"
            />
          }
        </div>
        <div class="c__product-infos-container">
          @if (displayStock) {
            <div class="c__stock" [ngClass]="{
                'is-in-stock' : stock?.online && !stock?.lowStock,
                'is-low-stock': stock?.online && stock?.lowStock,
                'is-out-of-stock': !stock?.online
              }">
              @if (stock?.online && !stock?.lowStock) {
                <sd-icon [size]="iconSize.xs" name="icon-check" />
              } @else if (stock?.online && stock?.lowStock) {
                <sd-icon [size]="iconSize.xs" name="icon-chrono" />
              }
              <p class="c__stock-info is-bold" [ngClass]="{
                'is-caption': !isMobile$,
                'is-overline': horizontalParentLayout
                }"
              >
                {{ ((stock?.online && !stock?.lowStock)
                  ? 'product.stock.inStock'
                  : (stock?.online && stock?.lowStock)
                    ? 'product.stock.lowStock.label'
                    : 'product.stock.outOfStock') | translate }}
                @if (stock?.releaseDate && !stock?.online) {
                  <span class="c__release-date is-medium">
                    {{ ('product.stock.nextReleaseDate'| translate) }} {{ stock?.releaseDate }}
                  </span>
                }
              </p>
            </div>
          }
          <ng-container>
            @if (deliveryText && stock?.online && !isForfait) {
              <div class="c__delivery" id="DeliveryText_{{pageTemplate}}Page_1">
                <p> <span class="c__pipe">|</span>{{ deliveryText }}</p>
              </div>
            }
          </ng-container>
        </div>
      </div>
    }
  </div>
}

@if (benefits && !isSmall && !isMinified && !isLoading) {
  <div class="c__benefit">
    @for (benefit of benefits; track benefit) {
      <sd-product-benefit
        [media]="benefit?.media"
        [description]="benefit.description"
        [brand]="brand"
        [horizontalParentLayout]="horizontalParentLayout"
      />
    }
  </div>
}

@if (isLoading) {
  <sd-skeleton
    [appearance]="skeletonAppearanceEnum.heading"
    [sizeChangeMobile]="false"
    [count]="2"
  />
}
<ng-template #templateRefSAV let-refSAV="refSAV" let-hasComma="hasComma">
  {{ refSAV }}
  @if (hasComma) {
    <span>, </span>
  }
</ng-template>
